/**
 * Shared days-value renderer for stock-management consignment configs.
 *
 * Colours the cell red past ``redAtDays`` and orange past ``orangeAtDays``.
 * Thresholds differ per exception (overdue PO vs unsent PO vs pending
 * transfer), so take them as inputs rather than hard-coding.
 */
import React from 'react'

export interface DaysValueRendererOptions {
  redAtDays: number
  orangeAtDays: number
  suffix?: string
}

export const createDaysValueRenderer =
  ({ redAtDays, orangeAtDays, suffix = 'd' }: DaysValueRendererOptions) =>
  (value: any): React.ReactNode => {
    const days = Number(value) || 0
    const color = days > redAtDays ? '#d32f2f' : days > orangeAtDays ? '#ed6c02' : 'inherit'
    return React.createElement(
      'span',
      { style: { color, fontWeight: days > redAtDays ? 500 : 400 } },
      `${days}${suffix}`,
    )
  }
